import * as types from '../actionTypes';
import type { TagDetailsIsReadyAction } from '../types';

export const tagDetailsIsReady = (meta = {}): TagDetailsIsReadyAction => ({
  type: types.TAG_DETAILS_READY,
  meta
});
